import { isNumber, isUndefined } from "lodash";
import { intersection, isEmpty, isNil } from "ramda";
import { match, P } from "ts-pattern";
import { calcFormula } from "../operation";
/**
 * @deprecated
 * 获取符合条件的规则
 */
export function deprecated_checkPropConditions(condDisp = [],
// 属性值
tempProp = [], nodeMetaDataProp = {}) {
  if (condDisp?.length) {
    const rules = condDisp.filter(i => i?.enable);
    for (let i = 0; i < rules.length; i++) {
      const rule = rules[i];
      if (rule) {
        const result = calcFormula(rule.formula?.formula, tempProp, {
          e: nodeMetaDataProp
        });
        if (result) {
          return rule;
        }
      }
    }
  }
  return undefined;
}
export function deprecated_checkVisibleByPropConditions(...args) {
  const rule = deprecated_checkPropConditions(...args);
  if (rule) {
    return !rule.disp;
  }
  return undefined;
}
export const UneditablePropType = ["auto_inc", "quote", "formula"];

/**
 * 根据属性的条件规则清空属性值
 */
export function deprecated_getResetPropValueByCondition(node, templateInfo) {
  const result = [];
  const nodeMetaData = isPiNode(node) ? node.metadata : node;
  for (let propIndex = 0; propIndex < templateInfo.prop.length; propIndex++) {
    const propConfig = templateInfo.prop[propIndex];
    const rule = deprecated_checkPropConditions(propConfig.condDisp, nodeMetaData.e._sys_temp[1], nodeMetaData.e);
    if (!rule?.disp && rule?.keepValue === "clear" && !UneditablePropType.includes(propConfig.type)) {
      result.push({
        propIndex,
        value: null,
        propType: propConfig.type
      });
    }
  }
  return result;
}

/**
 * 判断分组可见
 */
export function checkNodePropVisibleByGroup(prop) {
  if (!prop) return false;
  // FIXME: 当 originHide 存在时，说明 hide 被「可见分组」覆盖过
  if (!isUndefined(prop.originHide) && prop.hide) {
    return false;
  }
  return true;
}
const checkNumber = v => {
  if (isNumber(v)) return true;
  return !Number.isNaN(Number(v));
};
export function isPiNode(node) {
  if (isNil(node)) return false;
  if ("e" in node) {
    return false;
  }
  if ("value" in node && typeof node.value !== "string") {
    return false;
  }
  return true;
}

// 当「引用属性」匹配到了多个节点，可能会有多个值
const valueChecker = (v, checker) => {
  if (Array.isArray(v)) {
    for (let index = 0; index < v.length; index++) {
      const element = v[index];
      if (checker(element)) {
        return true;
      }
    }
    return false;
  } else {
    return checker(v);
  }
};
export const filterChecker = filterConfig => (node, currentUser) => {
  let valid = true;
  const propValues = isPiNode(node) ? node.tempInfo.prop : node.e._sys_temp[1];
  const currentStatus = isPiNode(node) ? node.tempInfo.status : node.e._sys_task_status.index;
  for (let ruleIndex = 0; ruleIndex < filterConfig.length; ruleIndex++) {
    const currentConfig = filterConfig[ruleIndex];
    const propIndex = currentConfig.index;
    const propValue = propValues[propIndex];
    if (currentConfig.key === "currentUserRoles") {
      const userPropValue = currentUser?.roles?.map(i => "group_" + i) || [];
      switch (currentConfig.op) {
        case "intersect":
          {
            if (isNil(userPropValue)) {
              valid = currentConfig.input.includes("_filter_unset");
            } else {
              valid = intersection(currentConfig.input, userPropValue).length > 0;
            }
            break;
          }
        case "empty":
          {
            if (isNil(userPropValue)) {
              valid = true;
              break;
            }
            if (isEmpty(userPropValue)) {
              valid = true;
              break;
            }
            valid = Array.isArray(userPropValue) ? isEmpty(userPropValue) : isNil(userPropValue);
            break;
          }
        case "notEmpty":
          valid = !isEmpty(userPropValue) && !isNil(userPropValue);
          break;
        default:
          break;
      }
      if (!valid) break;
    }

    // 增加状态的判断
    if (currentConfig.key === "status") {
      valid = currentConfig.input.includes(currentStatus);
      if (!valid) break;
    }
    if (currentConfig.key !== "prop") continue;
    if ((isNil(currentConfig.input) || currentConfig.input === "") && currentConfig.op !== "empty" && currentConfig.op !== "notEmpty") continue;
    switch (currentConfig.op) {
      case "textInclude":
        const checkText = v => v?.toLocaleLowerCase()?.includes(currentConfig.input[0]?.toLocaleLowerCase());
        valid = valueChecker(propValue, checkText);
        break;
      case "include":
        if (isNil(propValue)) {
          valid = currentConfig.input.includes("_filter_unset");
        } else {
          const value = Array.isArray(propValue) ? propValue : [propValue];
          valid = intersection(currentConfig.input, value).length === currentConfig.input.length;
        }
        break;
      case "intersect":
        if (isNil(propValue)) {
          valid = currentConfig.input.includes("_filter_unset");
        } else {
          const value = Array.isArray(propValue) ? propValue : [propValue];
          valid = intersection(currentConfig.input, value).length > 0;
        }
        break;

      /**
       * 数字属性
       * 日期属性
       *  */
      case "equal":
        valid = valueChecker(propValue, v => checkNumber(v) && currentConfig.input[0] === Number(v));
        break;
      case "greater":
        valid = valueChecker(propValue, v => checkNumber(v) && Number(v) > currentConfig.input[0]);
        break;
      case "greaterEqual":
        valid = valueChecker(propValue, v => checkNumber(v) && Number(v) >= currentConfig.input[0]);
        break;
      case "less":
        valid = valueChecker(propValue, v => checkNumber(v) && Number(v) < currentConfig.input[0]);
        break;
      case "lessEqual":
        valid = valueChecker(propValue, v => checkNumber(v) && Number(v) <= currentConfig.input[0]);
        break;
      case "notEqual":
        valid = valueChecker(propValue, v => checkNumber(v) && Number(v) !== currentConfig.input[0]);
        break;
      case "empty":
        {
          if (isNil(propValue)) {
            valid = true;
            break;
          }
          if (isEmpty(propValue)) {
            valid = true;
            break;
          }
          valid = Array.isArray(propValue) ? isEmpty(propValue) : isNil(propValue);
          break;
        }
      case "notEmpty":
        valid = !isEmpty(propValue) && !isNil(propValue);
        break;
      default:
        break;
    }
    if (!valid) break;
  }
  return valid;
};

/**
 * 获取符合条件的规则
 */
export function checkPropConditions(condDisp = [],
// 属性值
nodeMetaDataProp = {}, currentUserInfo) {
  if (!condDisp?.length) return undefined;
  const rules = condDisp.filter(i => i?.enable);
  for (let i = 0; i < rules.length; i++) {
    const rule = rules[i];
    if (rule) {
      const result = filterChecker(rule.condition)({
        e: nodeMetaDataProp
      }, {
        roles: currentUserInfo?.group_ids || []
      });
      if (result) {
        return rule;
      }
    }
  }
}

/**
 * todo: 支持单属性判断
 *
 * 根据条件规则计算
 */
export function getPropVisibleMap(node, tempInfo, currentUserInfo) {
  const nodeMetaData = isPiNode(node) ? node.metadata : node;

  // 先根据属性挑选出相关的「条件配置」
  const propConditionMap = match(tempInfo.temp_option).with({
    propCondition: P.array(P._)
  }, ({
    propCondition
  }) => {
    const result = {};
    propCondition.forEach(config => {
      if (!config.enable) return;
      config.results.forEach(r => {
        if (r.type !== "property_visible") return;
        r.targetProps.forEach(propIndex => {
          if (!result[propIndex]) {
            result[propIndex] = [];
          }
          result[propIndex].push(config);
        });
      });
    });
    return result;
  }).otherwise(() => null);
  const propVisibleMap = {};
  for (let propIndex = 0; propIndex < tempInfo.prop.length; propIndex++) {
    const prop = tempInfo.prop[propIndex];
    if (propConditionMap) {
      const rule = checkPropConditions(propConditionMap[propIndex], nodeMetaData.e, currentUserInfo);
      const ruleResult = rule?.results.find(r => r.type === "property_visible" && r.targetProps.includes(propIndex));
      if (!ruleResult || !("visible" in ruleResult)) continue;
      const visible = ruleResult.visible;
      if (typeof visible !== "undefined") propVisibleMap[propIndex] = visible === "show";
    } else {
      // TODO: 1.11 重构上线后删除
      const invisible = deprecated_checkVisibleByPropConditions(prop.condDisp, nodeMetaData.e._sys_temp[1], nodeMetaData.e);
      if (typeof invisible !== "undefined") propVisibleMap[propIndex] = !invisible;
    }
  }
  return propVisibleMap;
}
export function getPropGroupDefaultOpenMap(node, tempInfo, currentUserInfo) {
  const nodeMetaData = isPiNode(node) ? node.metadata : node;
  if (isEmpty(nodeMetaData)) return {};

  // 先根据分组 id 挑选出相关的「条件配置」
  const propConditionMap = match(tempInfo.temp_option).with({
    propCondition: P.array(P._)
  }, ({
    propCondition
  }) => {
    const result = {};
    propCondition.forEach(config => {
      if (!config.enable) return;
      config.results.forEach(r => {
        if (r.type !== "property_group_default_open") return;
        r.groups.forEach(groupId => {
          if (!result[groupId]) {
            result[groupId] = [];
          }
          result[groupId].push(config);
        });
      });
    });
    return result;
  }).otherwise(() => null);
  const propGroupDefaultOpenMap = {};
  if (propConditionMap) {
    for (let groupIndex = 0; groupIndex < tempInfo.prop_groups.length; groupIndex++) {
      const group = tempInfo.prop_groups[groupIndex];
      const rule = checkPropConditions(propConditionMap[group.id], nodeMetaData.e, currentUserInfo);
      const ruleResult = rule?.results.find(r => r.type === "property_group_default_open" && r.groups.includes(group.id));
      if (!ruleResult || !("defaultOpen" in ruleResult)) continue;
      const defaultOpen = ruleResult.defaultOpen;
      propGroupDefaultOpenMap[group.id] = defaultOpen;
    }
  }
  return propGroupDefaultOpenMap;
}

/*
 * 根据属性的条件规则清空属性值
 */
export function getResetPropValueByCondition(node, templateInfo, currentUserInfo) {
  const result = [];
  if (!templateInfo.temp_option?.propCondition) return deprecated_getResetPropValueByCondition(node, templateInfo);
  const nodeMetaData = isPiNode(node) ? node.metadata : node;
  for (let propIndex = 0; propIndex < templateInfo.prop.length; propIndex++) {
    const propConfig = templateInfo.prop[propIndex];
    const rule = checkPropConditions(templateInfo.temp_option.propCondition, nodeMetaData.e, currentUserInfo);
    if (!rule) continue;
    rule.results.forEach(ruleResult => {
      if (ruleResult.type !== "property_visible") return;
      if (ruleResult.visible === "hidden" && ruleResult.keepValue === "clear" && !UneditablePropType.includes(propConfig.type)) {
        result.push({
          propIndex,
          value: null,
          propType: propConfig.type
        });
      }
    });
  }
  return result;
}